import { IPayableSessionData } from "types/payableSession";

export const SET_PAYABLE_SESSION = "SET_PAYABLE_SESSION";

// TODO: consider if we should clear the session cookie when we set payable session to undefined?
export const setPayableSession = (
  session: IPayableSessionData | undefined
): Record<string, unknown> => ({
  type: SET_PAYABLE_SESSION,
  payload: session,
});
